import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Ic } from "./ui";
import { useSession } from "../session";
import { useT } from "../i18n";

// Colțul din dreapta al barei de sus.
//
// Erau patru ținte lipite una de alta — „Proiecte", „Organizație", avatarul și
// un buton „Logout" — dintre care cea mai zgomotoasă (chenar, pictogramă,
// text) era exact aceea pe care omul o apasă cel mai rar, și cea mai
// periculoasă. Rămâne una: avatarul. Sub el stau, în ordinea în care se
// folosesc, cele trei destinații ale contului, iar ieșirea din cont e ultima,
// după o linie.

export default function MeniuCont() {
  const { user, signOut } = useSession();
  const t = useT();
  const [deschis, setDeschis] = useState(false);
  const gazda = useRef<HTMLDivElement>(null);
  const path = useLocation().pathname;

  // Meniul se închide când te duci în altă parte — altfel rămâne deschis peste
  // pagina nouă, fiindcă navigarea nu demontează bara de sus.
  useEffect(() => setDeschis(false), [path]);

  useEffect(() => {
    if (!deschis) return;
    const inafara = (e: MouseEvent) => {
      if (!gazda.current?.contains(e.target as Node)) setDeschis(false);
    };
    const esc = (e: KeyboardEvent) => { if (e.key === "Escape") setDeschis(false); };
    document.addEventListener("mousedown", inafara);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", inafara);
      document.removeEventListener("keydown", esc);
    };
  }, [deschis]);

  const nume = user?.full_name || user?.email || "";
  const org = user?.organizations?.[0]?.name;

  return (
    <div className="ob-cont" ref={gazda}>
      <button className={`ob-cont-buton${deschis ? " on" : ""}`}
              onClick={() => setDeschis((d) => !d)}
              aria-haspopup="menu" aria-expanded={deschis}
              title={nume || t("cont.titlu")}>
        <span className="av">{initiale(nume)}</span>
        <Ic n="caret" s={14} />
      </button>

      {deschis && (
        <div className="card ob-cont-meniu" role="menu">
          <div className="ob-cont-cine">
            <b>{user?.full_name || user?.email}</b>
            {user?.full_name && <span>{user.email}</span>}
            {org && <span>{org}{(user?.organizations?.length ?? 0) > 1
              ? ` +${(user!.organizations.length - 1)}` : ""}</span>}
          </div>
          <hr className="ob-cont-linie" />
          <Link className="ob-cont-item" to="/projects" role="menuitem">
            <Ic n="grid" s={15} />{t("cont.proiecte")}
          </Link>
          {/* COLECȚIA E A OMULUI, deci se ajunge la ea de-aici, nu dintr-un
              proiect (v. migrarea 0045). */}
          <Link className="ob-cont-item" to="/tronsoane" role="menuitem">
            <Ic n="layers" s={15} />{t("cont.tronsoane")}
          </Link>
          <Link className="ob-cont-item" to="/organization" role="menuitem">
            <Ic n="users" s={15} />{t("cont.organizatie")}
          </Link>
          <Link className="ob-cont-item" to="/profile" role="menuitem">
            <Ic n="gear" s={15} />{t("cont.profil")}
          </Link>
          <hr className="ob-cont-linie" />
          <button className="ob-cont-item" role="menuitem" onClick={signOut}>
            <Ic n="logout" s={15} />{t("cont.iesi")}
          </button>
        </div>
      )}
    </div>
  );
}

function initiale(sursa: string): string {
  return sursa.split(/[\s.@]+/).filter(Boolean).slice(0, 2)
    .map((parte) => parte[0]?.toUpperCase() ?? "").join("");
}
